import { render, staticRenderFns } from "./SubmitComponent.vue?vue&type=template&id=a333ee78&scoped=true"
import script from "./SubmitComponent.vue?vue&type=script&lang=js"
export * from "./SubmitComponent.vue?vue&type=script&lang=js"
import style0 from "./SubmitComponent.vue?vue&type=style&index=0&id=a333ee78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a333ee78",
  null
  
)

export default component.exports